import { render } from "./WaInfoPanel.vue?vue&type=template&id=6df43b83"
import script from "./WaInfoPanel.vue?vue&type=script&lang=js"
export * from "./WaInfoPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__